import { Tags, TypeIcon } from 'src/components';
import { faExternalLinkAlt } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import Link from 'next/link';
import { exists } from 'src/utils/exists/exists';
import { getProfileUrl } from 'src/utils/profileUrl';
import theme from 'src/styles/theme';

const NameCell = ({ row }) => {
  const showLink = row.type !== 'group_pac' && row.type !== 'system';
  const contentType = exists(row.type)
    ? row.type
    : exists(row.content_type)
    ? row.content_type
    : 'hcp';
  const linkUrl = getProfileUrl(contentType, row?.provider_id);

  return (
    <div className="flex flex-col w-full">
      <div className="flex items-center">
        {showLink ? (
          <Link
            href={linkUrl}
            scroll={false}
            className="flex-grow text-inherit no-underline block"
          >
            <div className="flex items-center">
              {exists(row.type) && (
                <div className="flex items-center w-[1.1rem] h-full mr-2">
                  <TypeIcon
                    type={row.type}
                    style={{
                      color: theme.palette.primary.main,
                    }}
                  />
                </div>
              )}
              {row.name || 'n/a'}
              <Icon
                icon={faExternalLinkAlt}
                size="sm"
                style={{ marginLeft: '0.25rem' }}
              />
            </div>
          </Link>
        ) : (
          <>{row.name || 'n/a'}</>
        )}
      </div>
      {row.tags?.length > 0 && !exists(row.type) && (
        <div className="flex items-center">
          <Tags tags={row.tags} tagType="tag" size="small" />
        </div>
      )}
    </div>
  );
};

export default NameCell;
